module.exports = __webpack_public_path__ + "img/logo.ee3fccc7.png";